<template lang="pug">
  div
    vuetable(
      ref="vuetable2"
      :fields="fields"
      :api-url="`${server}/api/drug-storage/`"
      :css="boostrapCss"
      data-path="results"
      pagination-path=""
      :perPage="100"
      :append-params="moreParams" 
      detail-row-component="adc-drug-detail"
      @vuetable:cell-clicked="onCellClicked"
    )
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import readCookie from '@/vuex/functions/readCookie';
import server from '@/config';
import DrugDetail from './DrugDetail';

Vue.component('adc-drug-detail', DrugDetail);
Vue.component('expired-date', {
  name: 'expiredDate',
  props: ['rowData'],
  computed: {
    isExpired() {
      if (moment(this.rowData.expired_date, 'YYYY-MM-DD').diff(moment(), 'days') >= 0) {
        return false;
      }
      return true;
    },
  },
  template: `
    <span :class="{ 'red-text': isExpired }">
      {{ rowData.expired_date }}
    </span>
  `,
});

export default {
  props: ['rowData'],
  name: 'DrugListDrugStorages',
  data() {
    return {
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      boostrapCss: {
        tableClass: 'custom-table table',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      fields: [
        {
          name: 'device',
          title: '位置',
          callback: 'readablePosistion',
          titleClass: 'w-25',
        },
        {
          name: 'stock',
          title: '庫存',
        },
        {
          name: 'max_stock',
          title: '最大庫存',
        },
        {
          name: '__component:expired-date',
          title: '有效期限',
        },
        {
          name: 'patch_number',
          title: '批號',
          titleClass: 'w-25',
        },
      ],
      moreParams: {},
      server,
    };
  },
  components: {
    Vuetable,
  },
  created() {
    this.moreParams = {
      medication: this.rowData.medication.id,
      device__net__system: this.$parent.httpOptions.params.system,
    };
  },
  mounted() {
    // this.$refs.vuetable2.setData(this.rowData.drug_storage);
  },
  methods: {
    onCellClicked(data) {
      this.$refs.vuetable2.toggleDetailRow(data.id);
    },
    readablePosistion(val) {
      let pos = `${val.net.system.name} - ${val.net.open_times}藥櫃 - ${val.net.row_id}層`;
      if (val.pos_row !== 0) {
        pos = `${pos} - ${val.pos_row}列 - ${val.relative_col}行`;
      }
      if (val.specific_type === 'return_device') {
        pos = `${pos} (退藥盒)`;
      }
      return pos;
    },
  },
};
</script>




// WEBPACK FOOTER //
// DrugListDrugStorages.vue?57e4a627